import Axios from 'axios';
import produce from 'immer';

const initialState = {
  loggedIn: false,
  account: null,
  header: null
}

const authReducer = (state=initialState, action) => {
  switch(action.type) {
    case 'AUTH_LOGIN':
      var header = `Bearer ${action.payload.token}`;
      Axios.defaults.headers.common['Authorization'] = header;

      return {
        loggedIn: true,
        account: action.payload.user,
        header: header
      };

    case 'AUTH_RESET':
      Axios.defaults.headers.common['Authorization'] = null;

      return initialState;

    case 'AUTH_UPDATE_ACCOUNT':
      const nextState = produce(state, draftState => {
        draftState.account = action.payload
      });

      return nextState;

    default:
      return state;
  }
}

export default authReducer;